module.exports = __webpack_public_path__ + "img/logo.2b2c71ba.png";